import { render } from "./RecipeList.vue?vue&type=template&id=511f8a86&scoped=true"
import script from "./RecipeList.vue?vue&type=script&lang=js"
export * from "./RecipeList.vue?vue&type=script&lang=js"

import "./RecipeList.vue?vue&type=style&index=0&id=511f8a86&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511f8a86"]])

export default __exports__